import { ToggleButton, ToggleButtonGroup } from '@mui/material'
import { useEffect } from 'react'
import { E2FAMethod, E2FATab, ETranslationNs } from 'src/types'
import { HelperWrapper } from '../helper-wrapper'
import { useStyles } from './styles'

interface IProps {
  tab: E2FATab
  setFaMethod: (method: E2FATab) => void
  faRequired: boolean
  method: E2FAMethod | null
}

export const TwoFaModalTitle = ({ tab, setFaMethod, faRequired, method }: IProps) => {
  const classes = useStyles()

  useEffect(() => {
    if (method === E2FAMethod.Email) {
      setFaMethod(E2FATab.Email)
    } else if (method === E2FAMethod.Totp) {
      setFaMethod(E2FATab.Totp)
    } else {
      setFaMethod(E2FATab.None)
    }
  }, [method, setFaMethod])

  const handle2FAChange = (e: any, newMethod: E2FATab) => {
    if (newMethod === null) return
    setFaMethod(newMethod)
  }

  return (
    <div className={classes.titleWrapper}>
      <>
        <h2 className={classes.modalTitle}>
          <HelperWrapper t="user-profile-two-step-button" ns={ETranslationNs.UserProfile} />
        </h2>
        <ToggleButtonGroup
          className={classes.buttonsGroup}
          value={tab}
          exclusive
          size="small"
          color="primary"
          onChange={handle2FAChange}
        >
          <ToggleButton disabled={faRequired || !!method} value={E2FATab.None}>
            <HelperWrapper t="none-text" ns={ETranslationNs.UserProfile} />
          </ToggleButton>
          <ToggleButton disabled={!!method && method !== E2FAMethod.Email} value={E2FATab.Email}>
            <HelperWrapper ns={ETranslationNs.Common} t="email-input-label" />
          </ToggleButton>
          <ToggleButton disabled={!!method && method !== E2FAMethod.Totp} value={E2FATab.Totp}>
            <HelperWrapper t="authenticator-button-text" ns={ETranslationNs.UserProfile} />
          </ToggleButton>
        </ToggleButtonGroup>
      </>
    </div>
  )
}
